import styled from "styled-components";

export const FooterSection = styled.footer`
  .custom-text {
    width: 80%;
  }
`;
